import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { API_BASE } from '../lib/api';

const API = API_BASE;
const AuthContext = createContext(null);

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null = checking, false = not logged in
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API}/api/auth/me`, { withCredentials: true, timeout: 8000 });
      setUser(data);
    } catch {
      setUser(false);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { checkAuth(); }, [checkAuth]);

  const refreshUser = checkAuth;

  const login = async (identifier, password, rememberMe = true) => {
    const { data } = await axios.post(`${API}/api/auth/login`, { identifier, password, remember_me: rememberMe }, { withCredentials: true });
    setUser(data);
    return data;
  };

  const register = async (email, password, name, username = '', rememberMe = true) => {
    const { data } = await axios.post(`${API}/api/auth/register`, { email, password, name, username, remember_me: rememberMe }, { withCredentials: true });
    // Do NOT setUser yet — email verification is required. Caller will route to verify view.
    return data;
  };

  const logout = async () => {
    try { await axios.post(`${API}/api/auth/logout`, {}, { withCredentials: true }); } catch {}
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, refreshUser }}>
      {children}
    </AuthContext.Provider>
  );
};
